const getLocationHash = () => {
    const hash = window.location.hash;

    if (typeof hash === 'string' && hash.length > 0) {
        window.localStorage.setItem('ekLocationHash', hash);
        window.sessionStorage.setItem('ekLocationHashSet', '1');

        // remove hash
        // window.history.pushState('', document.title, window.location.pathname + window.location.search);
    } else {
        window.localStorage.removeItem('ekLocationHash');
    }
};

const executeLocationHash = () => {
    if (window.sessionStorage.getItem('ekLocationHashSet')) {
        return;
    }

    const hash = window.localStorage.getItem('ekLocationHash');

    if (typeof hash === 'string' && hash.length > 0) {
        window.location.href = `${hash}`;
    }
};

export {
    getLocationHash,
    executeLocationHash
};
